import React from 'react';
import { Typography } from '@forgeglobal/design-framework';
import { useStyles } from './style';

const LoadingPanel = () => {
  const classes = useStyles();

  return (
    <div className={classes.loadingWrapper}>
      <Typography variant="h6" className={classes.loadingTitle}>
        Loading
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        className={classes.loadingText}>
        Please wait
      </Typography>
    </div>
  );
};

export default LoadingPanel;
